export const isMoreThanOneElementArray = <T>(
  src: unknown
): src is [T, ...T[]] => Array.isArray(src) && src.length > 1
